export default __webpack_public_path__ + "static/bg-tower--mobile-27fc815df5a585ae09ff5725634c3d60.webp";